// import "../styles/button.css"
// const Button = ({ children, ...props }) => {
//   return <button {...props} className="defaultbtn">{children}</button>;
// };
// export default Button;

import "../styles/button.css";

// Button component
const Button = ({ children, outlined, loading, ...props }) => {
  const className = outlined ? "outlinedbtn" : "defaultbtn"; // Determine class based on the outlined prop

  return (
    <button {...props} className={className} disabled={loading}>
      {loading ? (
        <div className="loader"></div> // Loader animation
      ) : (
        children // Button text
      )}
    </button>
  );
};

export default Button;